export default function (options: jwplayer.CaptionsConfig = {}) {
    // additional config options required for playback
    return function (jwConfig: jwplayer.SetupConfig) {
        if (options.native === true) {
            jwConfig.renderCaptionsNatively = true;
            delete options.native;
        }

        if (Object.keys(options).length > 0) {
            jwConfig.captions = options;
        }

        return jwConfig;
    };
}
